import React from 'react';

const LoadingScreen = () => {
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
            <div className="flex flex-col items-center">
                <div className="w-16 h-16 border-4 border-emerald-100 border-t-emerald-600 rounded-full animate-spin"></div>
                <p className="mt-4 text-emerald-800 font-bold animate-pulse">Loading...</p>
            </div>
        </div>
    );
};

export default LoadingScreen;
